import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { SharedAnalyticsService } from '../../analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsHeaderLabels } from '../../enums/analytics.enum';
import { SECTIONS } from '../../models/Constants';

@Component({
  selector: 'app-profile-banner',
  templateUrl: './profile-banner.component.html',
  styleUrls: ['./profile-banner.component.scss'],
})
export class ProfileBannerComponent implements OnInit {

  @Input() pricipalUser: { ID_Bodega: number; NUD: number; Telefono: string; } = { ID_Bodega: 0, NUD: 0, Telefono: '' };
  @Input() hasButtonBack = true;

  constructor(
    private nav: NavController
    , private sharedAnalyticsS: SharedAnalyticsService
  ) { }

  ngOnInit() {
  }

  public backEvent = () => {
    this.nav.back({ animated: true, animationDirection: 'back' });
    this.sharedAnalyticsS.trackInteractionHeader({
      section: SECTIONS.PERFIL,
      label: EAnalyticsHeaderLabels.ATRAS
    });
  }

}
